import http from "../plugins/http";
import config from '../config';

const uri = config.services.rating;

class Moderation {
  async fetchCurrentModerationGroup(assetId) {
    console.log('ACC',`${uri}/api/v1/moderation/current/${assetId}` )
    const {data} = await http.get(`${uri}/api/v1/moderation/current/${assetId}`);
    return data.data;
  }

  async fetchModerationItem(itemId) {
    const {data} = await http.get(`${uri}/api/v1/moderation/item/${itemId}`);
    return data.data;
  }

  async fetchNextModeration(payload) {
    const {data} = await http.post(`${uri}/api/v1/moderation/confirm`, {...payload});
    return data.data;
  }

  async fetchModerationGroupByFilter(filter = {}) {
    const params = {};

    if(filter.state) {
      params.state = filter.state;
    }

    if(filter.assetId) {
      params.assetId = filter.assetId;
    }

    const {data} = await http.get(`${uri}/api/v1/moderation/list`, { params });

    return data.data.items;
  };

  async moderationIsAvailable(assetId) {
    const {data} = await http.get(`${uri}/api/v1/moderation/available/${assetId}`,);
    return data.data;
  }

  async createModeration(payload) {
    const {data} = await http.post(`${uri}/api/v1/moderation`, {...payload});
    return data.data;
  }

  async getModerationsList(filter) {
    const params = {};
    params.limit = filter.limit || 25;
    params.page = filter.page || 1;

    const {data} = await http.get(`${uri}/api/v1/moderation/list`, { params });
    return data.data;
  }

}

export default new Moderation();



// WEBPACK FOOTER //
// ./src/services/moderation.js